import { useEffect, useState, useContext } from 'react'
import { translate } from '../../translation'
import { PopupContext } from '../../_CONTEXT/PopupContext'
import MetaKeysCategories from '../METAKEYS/MetaKeysCategories'
import { Block, HookSources, MetaKeySources, Variable as VariableType } from 'Types'
import VariableList from './VariableList'
import { hookStore } from '_STORES/Hooks'
import RenderIf from '_COMPONENTS/GENERAL/RenderIf'

export const emptyBlock: Block = {
    variables: [],
    id: '',
    index: 0,
}

export const getBlockExemple = (block: Block) => {
    if (block.variables) {
        return block.variables
            .map(variable => ({ ...variable, value: variable.value.replace("{{line break}}", "\n") }))
            .map((variable, index) => {
                const value = variable.exemple ? variable.exemple : variable.value;
                // Don't add space after line break
                const separator = value.includes('\n') ? '' : (index !== (block.variables.length - 1) ? ' ' : '');
                return `${value}${separator}`;
            })
            .join('')
    }
    return '';
}

interface Props {
    defautBlock: Block | null;
    setter: (block: Block) => void;
    deleter?: (id: Block['id']) => void;
    showExemple?: boolean
    source?: MetaKeySources | null
    className?: string
}

export default function VariableBlock({
    defautBlock,
    setter,
    deleter,
    source,
    showExemple = true,
    className = ""
}: Props) {

    const { addPopupContent, showPopup } = useContext(PopupContext)
    const [block, setBlock] = useState<Block>(emptyBlock)

    const selectedHook = hookStore.selectedHookId
        ? hookStore.getHook(hookStore.selectedHookId)
        : null

    useEffect(() => {
        defautBlock && setBlock(defautBlock)
    }, [])

    useEffect(() => {
        setter && setter(block)
    }, [block])

    const addVariables = (variables: VariableType[]) => {
        showPopup(false);
        setBlock(prvBlock => ({
            ...prvBlock,
            variables: [...prvBlock.variables, ...variables]
        }));
    };

    const deleteBlock = () => {
        if (window.confirm(translate("Are you sure you want to delete this custom block ?"))) {
            deleter && deleter(block.id)
        }
    }

    const updateVariables = (variables: VariableType[]) => {
        setBlock(prv => ({
            ...prv,
            variables: variables
        }));
    }

    const addElement = () => {
        addPopupContent(<MetaKeysCategories onSelect={addVariables} source={source || selectedHook?.source} />)
    }

    return (
        <div className={`block-container relative p-2 ${className}`}>
            <div className="flex">
                {deleter
                    ? <div
                        className='delete-block text-red-700'
                        onClick={_ => deleteBlock()}
                    >×</div>
                    : null}
                <div>
                    <div className='italic'>{block.index === 0
                        // ? translate("Preferred block")
                        ? null
                        : <span>{translate("Fallback variables")} {block.index}</span>
                    }
                    </div>
                    <div className='flex items-center gap-1'>
                        <VariableList
                            variableArray={block.variables}
                            onUpdate={updateVariables}
                        />
                        {block.variables?.length
                            ? <div
                                className='add-new-field'
                                onClick={_ => addElement()}
                            >
                                {translate("Add new variables")}
                            </div>
                            : null}
                    </div>
                    {<RenderIf condition={!block.variables?.length}>
                        <div className='flex gap-6 w-100-p center'>
                            <div className='underline pointer' onClick={_ => addElement()}>
                                {translate("Add variables")}
                            </div>
                            <RenderIf condition={block.index === 0 && block.variables.length === 0}>
                                <div className='animate-pulse'>
                                    <div> 👈 Define the value to send to Pipedrive for this field</div>
                                </div>
                            </RenderIf>
                        </div>
                    </RenderIf>}

                </div>
            </div>
            {
                showExemple ?
                    <div className='flex justify-end mt-1 text-gray-700 text-xs italic' style={{ whiteSpace: 'pre-line' }}>
                        {getBlockExemple(block)}
                    </div>
                    : null
            }
        </div >
    );

}
